/**
 * Web shim for react-native-vector-icons.
 *
 * Native icon fonts are not wired into this web build, so we provide
 * lightweight text-symbol fallbacks for the icon names used in the app.
 * This keeps layout stable and makes the UI understandable on web.
 */

import React from 'react';
import { Text } from 'react-native';

const ICON_SYMBOLS = {
  'account-group': '👥',
  'account-group-outline': '👥',
  'account-outline': '👤',
  'account-clock-outline': '🕒',
  'account-cancel-outline': '🚫',
  'account-check-outline': '✅',
  'alert-outline': '⚠',
  'alert-rhombus-outline': '⚠',
  'arrow-left': '←',
  'archive-outline': '🗂',
  'bell-outline': '🔔',
  'bell-ring-outline': '🔔',
  'calendar': '📅',
  'calendar-month-outline': '📅',
  'chart-arc': '◔',
  'check-circle-outline': '✓',
  'check-decagram-outline': '✅',
  'chevron-down': '⌄',
  'chevron-left': '‹',
  'chevron-right': '›',
  'chevron-up': '⌃',
  'clock-outline': '🕒',
  'close': '✕',
  'close-circle-outline': '⊗',
  'close-octagon-outline': '⛔',
  'eye-outline': '👁',
  'eye-off-outline': '🙈',
  'filter-variant': '⚲',
  'hands-pray': '🙏',
  'heart-flash': '💗',
  'heart-outline': '♡',
  'heart-pulse': '💓',
  'home-outline': '⌂',
  'lightning-bolt-outline': '⚡',
  'magnify': '🔍',
  'shield-account-outline': '🛡',
  'shield-lock-outline': '🔒',
  'trending-up': '↗',
  'trophy': '🏆',
  'wifi-off': '📶',
};

const getFallbackSymbol = (name = '') => {
  const normalizedName = String(name).trim().toLowerCase();
  return ICON_SYMBOLS[normalizedName] || normalizedName.charAt(0).toUpperCase() || '?';
};

const createIconSet = () => {
  const Icon = ({ name = '', size = 24, color = '#000', style }) =>
    React.createElement(
      Text,
      {
        style: [
          {
            fontSize: size,
            color,
            fontFamily:
              'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI Symbol", "Apple Color Emoji", sans-serif',
            lineHeight: size,
            textAlign: 'center',
            includeFontPadding: false,
          },
          style,
        ],
        accessibilityLabel: String(name),
      },
      getFallbackSymbol(name),
    );

  Icon.getImageSource = async () => ({ uri: '' });
  Icon.loadFont = async () => {};
  Icon.hasIcon = (name) => !!ICON_SYMBOLS[String(name).trim().toLowerCase()];

  return Icon;
};

export const MaterialIcons = createIconSet();
export const MaterialCommunityIcons = createIconSet();
export const Ionicons = createIconSet();
export const FontAwesome = createIconSet();
export const FontAwesome5 = createIconSet();
export const Feather = createIconSet();
export const AntDesign = createIconSet();
export const Entypo = createIconSet();
export const EvilIcons = createIconSet();
export const Octicons = createIconSet();
export const SimpleLineIcons = createIconSet();
export const Zocial = createIconSet();
export const Fontisto = createIconSet();

export default createIconSet();
